import { SET_LOADING } from './constants';

// Action generator to control [state].auth.isLoading
// Should only be called as from other action generators
export const setUserLoading = (loading = true) => ({
  type: SET_LOADING,
  loading
});
